'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontIcon = undefined;

var _FontIcon = require('./FontIcon');

exports.default = _FontIcon.FontIcon;
exports.FontIcon = _FontIcon.FontIcon;


// WEBPACK FOOTER //
// ../~/react-toolbox/lib/font_icon/index.js